/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import PhotoUpload from './PhotoUpload'
import settings from '../settings'
import PhotoQrUpload from '../photo-qr-upload/PhotoQrUpload'

const Wrapper = styled.div`
  font-family: ${prop('theme.typography.paragraph.fontFamily')};
  font-size: 16px;
  font-weight: ${prop('theme.typography.paragraph.fontFamily')};
`

const PhotoUploaderSection = ({
  uploadedFiles,
  onChange,
  fileInputId,
  qrBlockId,
}) => {
  if (!uploadedFiles) {
    return null
  }

  return (
    <>
      <Wrapper>
        {settings.brand === 'magnet' ? (
          <PhotoQrUpload
            fileInputId={fileInputId}
            uploadedFiles={uploadedFiles}
            qrBlockId={qrBlockId}
            onChange={onChange}
          />
        ) : (
          <PhotoUpload
            fileInputId={fileInputId}
            uploadedFiles={uploadedFiles}
            onChange={onChange}
          />
        )}
      </Wrapper>
    </>
  )
}

PhotoUploaderSection.propTypes = {
  uploadedFiles: PropTypes.arrayOf(PropTypes.shape()),
  onChange: PropTypes.func.isRequired,
  fileInputId: PropTypes.string.isRequired,
  qrBlockId: PropTypes.string.isRequired,
}

PhotoUploaderSection.defaultProps = {
  uploadedFiles: null,
}

export default PhotoUploaderSection
